import { MenuItem as MuiMenuItem, styled } from '@mui/material';
import { ComponentProps } from 'react';
import { Link } from './Link';

// Элемент меню
export const MenuItem = styled((props: ComponentProps<typeof MuiMenuItem> & ComponentProps<typeof Link>) => (
  <MuiMenuItem component={Link} {...props} />
))();
